var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "os-and-browser" }, [
        _c("div", [
          _vm.os === "Windows" ? _c("span", [_c("windowsIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.os === "Mac OS" ? _c("span", [_c("macIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.os === "Linux" ? _c("span", [_c("LinuxIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.os === "iOS" ? _c("span", [_c("iosIcon")], 1) : _vm._e(),
          _vm._v(" "),
          _vm.os === "Android" ? _c("span", [_c("androidIcon")], 1) : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                " + _vm._s(_vm.os) + "\n            "),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { staticClass: "os-and-browser" }, [
        _vm.browser === "Chrome" ? _c("span", [_c("ChromeIcon")], 1) : _vm._e(),
        _vm._v(" "),
        _vm.browser === "Safari" ? _c("span", [_c("SafariIcon")], 1) : _vm._e(),
        _vm._v(" "),
        _vm.browser === "Edge" ? _c("span", [_c("EdgeIcon")], 1) : _vm._e(),
        _vm._v(" "),
        _vm.browser === "Firefox"
          ? _c("span", [_c("FirefoxIcon")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.browser === "Opera" ? _c("span", [_c("OperaIcon")], 1) : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n                " + _vm._s(_vm.browser) + " "),
          _c("span", { staticStyle: { "font-size": "12px" } }, [
            _vm._v(_vm._s(_vm.browserVersion)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }